// alternative-components/compactWidgetsCardDetails/ApprovalRequiredReviewAllModal.tsx
import { t } from "i18next";
import DialogXl from "@/app/models/dialogs/DialogXl";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";
import NoDataFound from "@/app/components/common/warning/NoDataFound";
import ActionCard from "../../../Dashboard/ActionCard";
import type { ApprovalCardItem } from "../../types/approval";
import type { GridRowClickEvent } from "@progress/kendo-react-grid";
import "./styles/CompactWidgets.scss";
import AlterApprovalRequiredTable from "../approval/AlterApprovalRequiredTable";

interface ApprovalRequiredReviewAllModalProps {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  tableList: ApprovalCardItem[];
  onRowClick: (event: GridRowClickEvent) => void;
  callCount: boolean;
  setCallCount: React.Dispatch<React.SetStateAction<boolean>>;
  onSelect: (value: any) => void;
}

const ApprovalRequiredReviewAllModal = ({
  open,
  onClose,
  isLoading,
  tableList,
  onRowClick,
  callCount,
  setCallCount,
  onSelect,
}: ApprovalRequiredReviewAllModalProps) => {
  return (
    <DialogXl
      title={t("approval_required")}
      subtitle={t("review_all")}
      open={open}
      handleClose={onClose}
      showFooter={false}
    >
      {isLoading ? (
        <SubmitLoading />
      ) : (
        <div className="gx-al-dashboard-table-header">
          <div className="gx-dashboard-table-container gx-review-all-card">
            {tableList?.length > 0 ? (
              <AlterApprovalRequiredTable
                onRowClick={onRowClick}
                tableList={tableList}
              />
            ) : (
              <div className="gx-dashboard-table-no-data gx-review-all-card">
                <NoDataFound message="No Approval Found" />
              </div>
            )}
          </div>

          <ActionCard
            callCount={callCount}
            setCallCount={setCallCount}
            onSelect={onSelect}
          />
        </div>
      )}
    </DialogXl>
  );
};

export default ApprovalRequiredReviewAllModal;
